// Updated PatientAnalysisDetails with charts, tooltips, animations, gauge chart, and PDF export
import React, { useEffect, useState, useMemo } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartTooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Legend
} from 'recharts';
import GaugeChart from 'react-gauge-chart';
import { toPng } from 'html-to-image';
import download from 'downloadjs';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { FaDownload, FaFilePdf } from 'react-icons/fa';
import FlipCard from './FlipCard';
import * as XLSX from "xlsx"; // at the top

const CardReviewDetails = () => {
  const [cardData, setCardData] = useState([]);

  const API_BASE_URL = process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_API_BASE_URL
    : process.env.REACT_APP_DEV_API_BASE_URL;

    useEffect(() => {
      const fetchExcelData = async () => {
        try {
          const res = await fetch(`${process.env.PUBLIC_URL}/data/ConversationAIly_Case_Vignettes.xlsx`);
          const blob = await res.blob();
          const arrayBuffer = await blob.arrayBuffer();
          const workbook = XLSX.read(arrayBuffer, { type: "array" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet);
  
          setCardData(jsonData);  // 🔁 Keep full patient row
        } catch (err) {
          console.error("Failed to read Excel file:", err);
        }
      };
  
      fetchExcelData();
    }, []);
  
    return (
      <div className="max-w-7xl mx-auto text-gray-900">
        {cardData.length > 0 && (
          <>
            <h1 className="text-4xl text-center my-6 pb-4 font-bold text-[#1D3A73]">
              🧾 Select your case to test
            </h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {cardData.map((patient, index) => (
                <FlipCard
                  key={index}
                  patient={patient} // ✅ Pass the full object
                  buttonLabel="Start Consult"
                  onClick={() => alert(`Consult started for ${patient["Patient Name"]}`)}
                />
              ))}
            </div>
          </>
        )}
      </div>
    );
  };
  
  export default CardReviewDetails;